import React, { useState, useEffect } from 'react';
import { useInView } from './hooks/useInView';
import { useParallax } from './hooks/useParallax';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import BenefitsHighlightsSection from './components/BenefitsHighlightsSection';
import PainPointsSection from './components/PainPointsSection';
import HowItWorksSection from './components/HowItWorksSection';
import FAQSection from './components/FAQSection';
import HealthIsSection from './components/HealthIsSection';
import EmployeeEmployerAdvantages from './components/EmployeeEmployerAdvantages';
import './styles/animations.css';

function App() {
  const [customerCount, setCustomerCount] = useState(0);
  const [consultingCount, setConsultingCount] = useState(0);
  const [experienceYears, setExperienceYears] = useState(0);
  const [parallaxRef, parallaxOffset] = useParallax();

  const [heroRef, heroInView] = useInView();
  const [statsRef, statsInView] = useInView();
  const [benefitsHighlightsRef, benefitsHighlightsInView] = useInView();
  const [howItWorksRef, howItWorksInView] = useInView();
  const [faqRef, faqInView] = useInView();
  const [employeeEmployerRef, employeeEmployerInView] = useInView();

  useEffect(() => {
    const duration = 2000;
    const customersInterval = setInterval(() => {
      setCustomerCount(prev => Math.min(prev + 10, 300));
    }, duration / 50);

    const consultingInterval = setInterval(() => {
      setConsultingCount(prev => Math.min(prev + 2, 99));
    }, duration / 50);

    const experienceInterval = setInterval(() => {
      setExperienceYears(prev => Math.min(prev + 1, 7));
    }, duration / 7);

    return () => {
      clearInterval(customersInterval);
      clearInterval(consultingInterval);
      clearInterval(experienceInterval);
    };
  }, []);

  const handleCTAClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open('https://calendly.com/beratung-ciafardini-consulting/30min', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="w-full">
      <Navbar />
      
      <HeroSection 
        inView={heroInView} 
        forwardedRef={heroRef} 
        handleCTAClick={handleCTAClick} 
        parallaxRef={parallaxRef} 
        parallaxOffset={parallaxOffset} 
      />
      
      <StatsSection 
        inView={statsInView} 
        forwardedRef={statsRef} 
        customerCount={customerCount} 
        consultingCount={consultingCount} 
        experienceYears={experienceYears} 
      />
      
      <BenefitsHighlightsSection 
        inView={benefitsHighlightsInView} 
        forwardedRef={benefitsHighlightsRef} 
      />
      
      <PainPointsSection handleCTAClick={handleCTAClick} />
      
      <HealthIsSection />
      
      <EmployeeEmployerAdvantages
        inView={employeeEmployerInView}
        forwardedRef={employeeEmployerRef}
        handleCTAClick={handleCTAClick}
      />
      
      <HowItWorksSection 
        inView={howItWorksInView} 
        forwardedRef={howItWorksRef} 
        handleCTAClick={handleCTAClick} 
      />
      
      <FAQSection 
        inView={faqInView} 
        forwardedRef={faqRef} 
        handleCTAClick={handleCTAClick} 
      />
      
      <Footer />
    </div>
  );
}

export default App;